import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from 'src/app/services/language.service';
import { BikeUploadResultDialogData } from './bulk-upload-result-dialog-data';

@Component({
  selector: 'app-bulk-upload-result-dialog',
  standalone: false,
  templateUrl: './bulk-upload-result-dialog.component.html',
  styleUrl: './bulk-upload-result-dialog.component.scss'
})
export class BulkUploadResultDialogComponent implements OnInit {

  public completedBikes: string[] = [];
  public completedBikesString: string = "";
  public duplicatedBikes: string[] = [];
  public duplicatedBikesString: string = "";
  public notAllowedBikes: string[] = [];
  public notAllowedBikesString: string = "";

  constructor(public dialogRef: MatDialogRef<BulkUploadResultDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: { data: BikeUploadResultDialogData },
    public languageService: LanguageService) {

    if (data.data.completed?.length>0) {
      this.completedBikes = data.data.completed;
      this.completedBikesString = this.languageService.languageJSON.ComponentRecalled_Completed.replace("$number", data.data.completed.length);
    }
    if (data.data.duplicates?.length>0) {
      this.duplicatedBikes = data.data.duplicates;
      this.duplicatedBikesString = this.languageService.languageJSON.ComponentRecalled_Duplicates.replace("$number", data.data.completed.length);
    }
    if (data.data.notAllowed?.length>0) {
      this.notAllowedBikes = data.data.notAllowed;
      this.notAllowedBikesString = this.languageService.languageJSON.ComponentRecalled_Invalid.replace("$number", data.data.notAllowed.length);
    }
  }

  ngOnInit(): void {
  }
}